import React from 'react';
import { ShieldCheckIcon, ZapIcon, UsersIcon, AwardIcon } from 'lucide-react';
export function TrustSignals() {
  const signals = [{
    icon: AwardIcon,
    text: 'Accredited Schools Only'
  }, {
    icon: ZapIcon,
    text: 'Fast, Free Matching'
  }, {
    icon: UsersIcon,
    text: '2M+ Students Matched'
  }, {
    icon: ShieldCheckIcon,
    text: 'Secure & Private'
  }];
  return <div className="w-full bg-white border-y border-gray-200 py-6 shadow-sm" data-id="element-352">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-353">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center md:text-left" data-id="element-354">
          {signals.map((signal, index) => {
          const Icon = signal.icon;
          return <div key={index} className="flex flex-col md:flex-row items-center justify-center md:justify-start space-y-2 md:space-y-0 md:space-x-3" data-id="element-355">
                <div className="p-2 bg-light rounded-full text-navy" data-id="element-356">
                  <Icon className="w-5 h-5" data-id="element-357" />
                </div>
                <span className="text-sm font-medium text-gray-700" data-id="element-358">
                  {signal.text}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}